import { create } from "zustand";

const rootEl = document.getElementById("root");

export const useCustomerStore = create((set, get) => ({
  customer: {
    id: rootEl?.dataset.customerId,
    email: rootEl?.dataset.customerEmail,
  },
}));
